import { TaskListItem } from '@myapp/contract'

function isMidnightDate(iso: string): boolean {
  const d = new Date(iso)
  return d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0
}

export function buildTimedTasksByTechnician(taskItems: TaskListItem[]): Map<string, TaskListItem[]> {
  const map = new Map<string, TaskListItem[]>()
  for (const task of taskItems) {
    if (!task.assignedTechnician || !task.plannedStart) continue
    if (task.needsRescheduling) continue
    if (isMidnightDate(task.plannedStart)) continue
    const id = String(task.assignedTechnician.id)
    if (!map.has(id)) map.set(id, [])
    map.get(id)!.push(task)
  }
  return map
}
